import { useResize } from 'app/lib/hooks/useResize';
import { DashboardContainer } from 'widgets/dashboardContainer';
import { HallmapEventDashboard } from 'widgets/hallmapEventDashboard';
import { MobileIndex } from 'widgets/mobileIndex';
import { TimeLine } from 'widgets/timeLine';

export const HomePage = () => {
  const { 
    isScreenMd
  } = useResize();

	return (
		<DashboardContainer>
			{isScreenMd && <TimeLine />}
      {
        isScreenMd ? 
        <HallmapEventDashboard /> : 
        <MobileIndex />
      }
		</DashboardContainer>
	);
};
